export default "__VITE_ASSET__aJ_Jvo6i__"